import React, { useEffect, useState } from "react";

import {
  Box,
  makeStyles,
  TableBody,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import CreateIcon from "@material-ui/icons/Create";

import Container from "../../components/Container";
import Navigation from "../../components/Navigation/Navigation";
import rodaUsers from "../../assets/images/rode.png";
import EditIcon from "../../components/Table/EditIcon";
import DeleteIcon from "../../components/Table/DeleteIcon";
import ConfirmationModal from "../../components/ConfirmationModal";
import Button from "../../components/Button";
import ModalDialog from "../../components/Form/ModalDialog";
import LightPurpleContainer from "../../components/LightPurpleContainer";
import Table from "../../components/Table/Table";
import TableHeadItem from "../../components/Table/TableHeadItem";
import TableInfoItem from "../../components/Table/TableInfoItem";
import { deactivateUserById, getAllRodaUsers, reactivateUserById } from "../../api/user";
import { User } from "../../types/hospital";
import UserForm from "../../components/Form/UserForm";
import { blankUser } from "../../constants/objects";
import MetaDecorator from "../../components/MetaDecorator";
import { INACTIVE } from "../../constants/status";
import ActivateIcon from "../../components/Table/ActivateIcon";
import { handleRodaStatusChange } from "../RodaHomepage/util/handleRodaStatusChange";

const useStyles = makeStyles((theme: Theme) => ({
  img: {
    width: "40rem",
    margin: theme.spacing(6, 0, -4, 0),
    [theme.breakpoints.down("sm")]: {
      width: "20rem",
      marginBottom: 0,
    },
  },
  editIcon: {
    fontSize: theme.spacing(2.2),
    color: theme.palette.primary.main,
  },
  title: {
    color: theme.palette.primary.main,
    display: "inline-block",
    fontSize: theme.spacing(2.5),
    fontWeight: "bold",
    margin: theme.spacing(1.8),
  },
  inactive: {
    color: theme.palette.grey["600"]
  }
}));

export default function RodaUserAdministration() {
  const classes = useStyles();
  const [rodas, setRodas] = useState<User[]>([]);
  const [editRoda, setEditRoda] = useState<User>(blankUser);
  const [rodaId, setRodaId] = useState<number>();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
  const [triggerUseEffect, setTriggerUseEffect] = useState<boolean>(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  const [reactivateModalOpen, setReactivateModalOpen] = useState<boolean>(false);

  const deactivateRoda = (rodaId: number) =>
    handleRodaStatusChange(rodaId, deactivateUserById, getRodas, () => setDeleteModalOpen(false));

  const reactivateRoda = (rodaId: number) =>
    handleRodaStatusChange(rodaId, reactivateUserById, getRodas, () => setReactivateModalOpen(false));


  async function getRodas() {
    const response = await getAllRodaUsers();
    setRodas(response.data.userDTOList);
  }

  useEffect(() => {
    getRodas();
  }, [triggerUseEffect]);

  return (
    <>
      <MetaDecorator />
      <Navigation />
      <Box pb={8}>
        <Container>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img src={rodaUsers} alt="rode" className={classes.img} />
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="button"
              startIcon={<AddRoundedIcon />}
              onClick={() => {
                setEditRoda(blankUser);
                setModalOpen(true);
              }}
            >
              Dodaj Rodu
            </Button>
            <ModalDialog
              modalOpen={modalOpen}
              handleClose={() => setModalOpen(false)}
              maxWidth="md"
              title={
                <Typography className={classes.title}>Dodaj Rodu</Typography>
              }
              icon={<AddRoundedIcon className={classes.editIcon} />}
            >
              <UserForm
                hospitalId={null}
                userUpdate={editRoda}
                setTriggerUseEffect={() =>
                  setTriggerUseEffect(!triggerUseEffect)
                }
                handleClose={() => setModalOpen(false)}
              />
            </ModalDialog>
          </div>
          <LightPurpleContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableHeadItem>Ime i prezime</TableHeadItem>
                  <TableHeadItem>Email</TableHeadItem>
                  <TableHeadItem>Akcija</TableHeadItem>
                </TableRow>
              </TableHead>
              <TableBody>
                {rodas.map((user) => (
                  <TableRow key={user.name}>
                    <TableInfoItem className={user.status === INACTIVE ? classes.inactive : ""}>
                      {user.name + " " + user.surname}
                    </TableInfoItem>
                    <TableInfoItem className={user.status === INACTIVE ? classes.inactive : ""}>{user.email}</TableInfoItem>
                    <TableInfoItem>
                      {user.status !== INACTIVE && (
                        <>
                      <EditIcon
                        onClick={() => {
                          setEditRoda(user);
                          setEditModalOpen(!modalOpen);
                        }}
                      />
                      <DeleteIcon
                        onClick={() => {
                          setRodaId(user.id);
                          setDeleteModalOpen(!modalOpen);
                        }}
                      />
                        </>)}
                      {user.status === INACTIVE && (
                        <ActivateIcon
                          onClick={() => {
                            if (user.id) {
                              setRodaId(user.id);
                            }
                            setReactivateModalOpen(true);
                          }}
                        />
                      )}
                    </TableInfoItem>
                  </TableRow>
                ))}
                {reactivateModalOpen && (
                  <ConfirmationModal
                    modalOpen={reactivateModalOpen}
                    handleAction={() => reactivateRoda(rodaId!)}
                    handleClose={() => setReactivateModalOpen(false)}
                    modalText={
                      "Jeste li sigurni da želite ponovno aktivirati korisnički račun Rode?"
                    }
                    title={"Jeste li sigurni?"}
                  />
                )}
                <ConfirmationModal
                  modalOpen={deleteModalOpen}
                  handleAction={() => deactivateRoda(rodaId!)}
                  handleClose={() => setDeleteModalOpen(false)}
                  modalText={
                    "Jeste li sigurni da želite deaktivirati korisnički račun Rode?"
                  }
                  title={"Jeste li sigurni?"}
                />
                <ModalDialog
                  modalOpen={editModalOpen}
                  handleClose={() => setEditModalOpen(false)}
                  maxWidth="md"
                  title={
                    <Typography className={classes.title}>
                      Uredi informacije o Rodi
                    </Typography>
                  }
                  icon={<CreateIcon className={classes.editIcon} />}
                >
                  <UserForm
                    hospitalId={null}
                    userUpdate={editRoda}
                    setTriggerUseEffect={() =>
                      setTriggerUseEffect(!triggerUseEffect)
                    }
                    handleClose={() => setEditModalOpen(false)}
                  />
                </ModalDialog>
              </TableBody>
            </Table>
          </LightPurpleContainer>
        </Container>
      </Box>
    </>
  );
}
